const environment = process.env.REACT_APP_ENVIRONMENT;
const localPort = process.env.REACT_APP_API_PORT;
let apiRequestUrl = "";

switch (environment) {
    case 'local':
        apiRequestUrl = `http://localhost:${ localPort }`;
        break;
    case 'staging':
        apiRequestUrl = 'https://master-api-staging.simplybenefits.ca';
        break;
    case 'production':
        apiRequestUrl = 'https://master-api.simplybenefits.ca';
        break;
    default:
        apiRequestUrl = 'https://master-api-staging.simplybenefits.ca';
        break;
}

export default {
    apiRequestUrl
};